<template>
    <div>
        <b-modal id="cost-unit-edit-modal" hide-footer no-close-on-backdrop size="xl" title="Schadenposition bearbeiten"
            :visible="isModalOpen" @hide="hideReset()" @show="loadForm">
            <div class="record-cost-unit-edit-modal">
                <csp-desktop-info-card
                    ref="costUnitInfoCard"
                    :cols="12"
                    :form-context="formContext"
                    icon="inticon-users"
                    title="Kunde"
                    @cancel-form="reset"
                    @save="saveCostUnitFormData">
                    <csp-record-detail-cost-unit-basedata
                        :form-context="formContext"
                        :hide-for-group-options="hideForGroupOptions"
                        :record-id="recordId"/>
                    <hr>
                    <h2>Zahlungen</h2>
                    <b-row v-for="subformIdentifier in formContext.form.getSubformIdentifiers()"
                        :key="subformIdentifier"
                        class="mt-3">
                        <csp-desktop-info-card-element
                            class="col-5"
                            :form-context="formContext"
                            label="Art der Zahlung"
                            :options-loader="() => loadPaymentTypeOptions(subformIdentifier)"
                            property="paymentType"
                            :required="true"
                            :subform-identifier="subformIdentifier"
                            type="autocomplete"
                            @change="handlePaymentTypeChange(subformIdentifier)"/>
                        <csp-desktop-info-card-element
                            class="col-2"
                            :form-context="formContext"
                            label="Bezahlt am"
                            property="datePaid"
                            :required="true"
                            :subform-identifier="subformIdentifier"
                            type="datepicker"/>
                        <csp-desktop-info-card-element
                            class="col-2"
                            :form-context="formContext"
                            label="Betrag"
                            property="amount"
                            :required="true"
                            :subform-identifier="subformIdentifier"
                            type="currency"/>
                        <csp-desktop-info-card-element
                            class="col-3"
                            :form-context="formContext"
                            label="Bemerkung"
                            property="description"
                            :subform-identifier="subformIdentifier"
                            type="text"/>
                    </b-row>
                    <b-row v-if="!transientPaymentAdded" class="mt-2 mb-5" no-gutters>
                        <b-button class="col-12" size="sm" variant="primary" @click="addPayment">
                            Zahlung hinzufügen
                        </b-button>
                    </b-row>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import CostUnitBasedata from '@desktop/components/record/cost-unit/RecordCostUnitBasedata.vue';
    import CostUnitPaymentMixin from '@desktop/components/mixins/CostUnitPaymentMixin';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CostUnitEditModal',
        components: {
            'csp-record-detail-cost-unit-basedata': CostUnitBasedata,
        },
        mixins: [FormDataMixin, CostUnitPaymentMixin],
        props: {
            hideForGroupOptions: {
                type: Array,
                default: null,
            },
            costUnitId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close', 'updated'],
        data() {
            return {
                transientPaymentAdded: false,
            }
        },
        methods: {
            // TODO Facelift: Prüfung auf Overpayments wie in
            //  csp/resources/js/desktop/widget/form/cost-unit-payment.js:hasOverpayment
            amountOpenCopayment() {
                return this.formContext.form.getProperty('amountOpenCopayment');
            },
            amountOpenInsurance() {
                return this.formContext.form.getProperty('amountOpenInsurance');
            },
            amountOpenVat() {
                return this.formContext.form.getProperty('amountOpenVat');
            },
            loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadCostUnit(this.recordId, this.costUnitId);
                }
                this.loadFormData(loadFunction);
            },
            addPayment() {
                const loadFunction = (objectId, postData) => {
                    return recordRepository.addCostUnitPayment(this.recordId, this.costUnitId, postData);
                }
                this.transientPaymentAdded = true;
                this.reloadFormData(this.formContext, loadFunction);
            },
            buildSaveFunction() {
                return (objectId, postData) => {
                    return recordRepository.saveCostUnitWithPayments(this.recordId, this.costUnitId, postData);
                };
            },
            hideReset() {
                this.$refs.costUnitInfoCard.cancelFormData();
            },
            reset() {
                this.transientPaymentAdded = false;
                this.formContext.isLoaded = false;
                this.$emit('close');
            },
            saveCostUnitFormData(formContext) {
                const saveFunction = this.buildSaveFunction();
                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.$emit('updated');
                    this.reset();
                });
            },
        },
    }
</script>
